import { sendTrackingParams } from './tracking';

export const trackGuestInfoInteraction = (trackAction) => {
  sendTrackingParams(
    {
      eventType: 'interactions',
      interaction: `amend:editguest:${trackAction}`,
    },
    false,
  );
};

export const trackSucessUpdateField = (trackField) => {
  sendTrackingParams(
    {
      eventType: 'interactions',
      interaction: `amend:editguest:changed:${trackField}`,
    },
    false,
  );
};
